const Academics = () => {
  return (
    <section id="academics" className="section">

      <h2>📚 Academics & Facilities</h2>

      <div className="grid">
        <div className="box">
          <img src="/images/assembly.jpg.webp" alt="" />
          <p>Morning Assembly & Discipline</p>
        </div>

        <div className="box">
          <img src="/images/26.webp" alt="" />
          <p>Achievements & Awards</p>
        </div>

        <div className="box">
          <img src="/images/sports.jpg.webp" alt="" />
          <p>Sports & Physical Education</p>
        </div>
      </div>
    </section>
  );
};

export default Academics;
